var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"header",staticClass:"header",class:{scrolledHeader: _vm.scrolledHeader }},[_c('div',{staticClass:"container"},[_c('navbar',{attrs:{"items":_vm.navbarItems}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }